import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, UtensilsCrossedIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/51BC9ijpp2HB4DpBwP8Cpo/ChatGPT_Image_11_ago_2026,_18_50_17.png';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: UtensilsCrossedIcon,
  label: 'Menús para 365 días'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function HeroSection() {
  return <section className="relative overflow-hidden border-b border-[var(--violet)]/30" data-id="element-100" data-mp="2rrfqiisuos65">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[var(--violet)]/25 blur-[120px]" aria-hidden="true" data-id="element-101" data-mp="3fht81fdt78mh" />
      <div className="pointer-events-none absolute right-0 top-40 h-[320px] w-[520px] rounded-full bg-[var(--lilac)]/15 blur-[130px]" aria-hidden="true" data-id="element-102" data-mp="2fgjwcook16kf" />
      <div className="relative mx-auto max-w-6xl px-4 py-16 sm:py-20 lg:py-24" data-id="element-103" data-mp="2p5v7shywynbh">
        <div className="grid items-center gap-12 lg:grid-cols-2" data-id="element-104" data-mp="2kelen7e5p1uu">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-105" data-mp="2kdaf5jrqug9j">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-[var(--lilac)]/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--lilac-light)]" data-id="element-106" data-mp="2u3d5fc7hdg46">
              🦋 Sistema Keto 365
            </p>
            <h1 className="text-center font-display text-4xl font-extrabold leading-[1.05] text-[var(--cream)] sm:text-5xl md:text-6xl" data-id="element-107" data-mp="3330b4a78t831">
              Todo tu año keto,{' '}
              <span className="text-[var(--lilac)]" data-id="element-108" data-mp="18smuhsbotl2d">ya resuelto.</span>
            </h1>
            <p className="mt-5 text-lg font-semibold text-[var(--violet-light)]" data-id="element-109" data-mp="38umn2grn8or8">
              Sistema Keto 365 — 6 Tomos + 6 Bonos
            </p>
            <p className="mt-5 max-w-lg text-white/75" style={{
            fontSize: "14px"
          }} data-id="element-110" data-mp="3irimlwzke0jn">
              Menús planificados + listas de compras + recetas con ingredientes
              del súper argentino. Sin contar macros. Sin improvisar. Sin
              abandonar en la segunda semana.
            </p>

            <div className="mt-6 flex flex-wrap gap-2" data-id="element-111" data-mp="lw6lfid80ep">
              {badges.map(b => <span key={b.label} className="inline-flex items-center gap-2 rounded-lg border border-[var(--violet)]/30 bg-white/[0.04] px-3 py-1.5 text-sm text-white/80" data-id="element-112" data-mp="5cmcctupe59x">
                  <b.icon className="h-4 w-4 text-[var(--lilac)]" aria-hidden="true" data-id="element-113" data-mp="ee2b24c5oiyb" />
                  {b.label}
                </span>)}
            </div>

            <div className="mt-8 max-w-md" data-id="element-114" data-mp="23vzj53muddon">
              <CtaButton href="https://www.sistemaketo.store/cart/48132893868084:1" variant="lilac" data-id="element-115" data-mp="1yvbidq8t9ih8">
                Quiero mi Sistema Keto
              </CtaButton>
            </div>

            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-white/60" data-id="element-116" data-mp="1pvewfwdt2xpv">
              {trust.map(t => <span key={t.label} className="inline-flex items-center gap-1.5" data-id="element-117" data-mp="2mk4fhq165wdf">
                  <t.icon className="h-4 w-4 text-[var(--violet-light)]" aria-hidden="true" data-id="element-118" data-mp="2ijud0ncl5o3b" />
                  {t.label}
                </span>)}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-semibold text-[var(--cream)]" data-id="element-119" data-mp="28roj382rwwlh">
              <span data-id="element-120" data-mp="31hn48sduk9kv">365 días de menús</span>
              <span className="text-[var(--violet)]" data-id="element-121" data-mp="31glucr8kht4q">·</span>
              <span data-id="element-122" data-mp="2l25szzxx3q58">6 Tomos</span>
              <span className="text-[var(--violet)]" data-id="element-123" data-mp="2l148z5yxbtbd">·</span>
              <span data-id="element-124" data-mp="2q2a39888fon0">6 Bonos</span>
              <span className="text-[var(--violet)]" data-id="element-125" data-mp="2q3bqeb2iw1l3">·</span>
              <span className="inline-flex items-center gap-1" data-id="element-126" data-mp="2c2isdgd0iod8">
                4.9/5
                <StarIcon className="h-4 w-4 fill-[var(--lilac)] text-[var(--lilac)]" aria-hidden="true" data-id="element-127" data-mp="2h0sp3vedxx0y" />
              </span>
            </div>
          </motion.div>

          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} data-id="element-128" data-mp="38si0j9p93kva">
            <div className="pointer-events-none absolute inset-0 rounded-full bg-[var(--lilac)]/15 blur-3xl" aria-hidden="true" data-id="element-129" data-mp="2zyn5wvlr9ctw" />
            <img src={HERO_IMAGE} alt="Sistema Keto 365: pack completo con 6 tomos, 6 bonos y el protocolo Keto Turbo" className="relative mx-auto w-full max-w-xl drop-shadow-2xl" data-id="element-130" data-mp="3sgr4eh05pfam" />
          </motion.div>
        </div>
      </div>
    </section>;
}